<template>
  <div>
    <i class="el-icon-document"></i>
    <span>{{ source.name }}</span>
    <span
      :class="[isImageType(source.name) ? 'file_style' : 'unClick_style']"
      @click.stop="showImgPreview"
      >预览</span
    >
    <span class="base-hover-char" @click="download">下载</span>
    <!-- 图片预览 -->
    <el-image-viewer
      v-if="showViewer"
      :on-close="closeViewer"
      :url-list="bigImgList"
    />
  </div>
</template>

<script>
import { downloadByUrl } from "@/utils/common.js";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";

export default {
  components: { ElImageViewer },
  props: {
    source: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      showViewer: false,
      bigImgList: [],
    };
  },
  methods: {
    closeViewer() {
      this.showViewer = false;
    },
    download() {
      const { name, url } = this.source;
      downloadByUrl(name, url);
    },
    // 查看大图
    showImgPreview() {
      const { name, url } = this.source;
      if (!this.isImageType(name)) {
        return;
      }
      this.showViewer = true;
      this.bigImgList = [url];
    },
    // 判断文件类型：图片
    isImageType(name) {
      if (name) {
        const urlIndex = name.lastIndexOf(".");
        let ext = name.substr(urlIndex + 1);
        let flag =
          ["png", "jpg", "jpeg", "gif", "svg"].indexOf(ext.toLowerCase()) !==
          -1;
        return flag;
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
span {
  margin-right: 15px;
}
.file_style {
  color: #3a85ff;
  cursor: pointer;
  margin-left: 16px;
}
.unClick_style {
  color: #96a1b2;
  cursor: not-allowed;
  margin-left: 16px;
}
</style>